<app-patient-form
  [patient]="null"
  action="{{ 'new' | translate }}"
  (close)="closeForm($event)">
</app-patient-form>
